var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-link',{attrs:{"href":_vm.url,"download":"","target":"_blank"}},[_c('b-icon-download',{attrs:{"font-scale":"2"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }